import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Adminadd = () => {
  const API =process.env.REACT_APP_API
  const navi = useNavigate();
  const [getData, setgetData] = useState([]); // State to store fetched data
  const [loading, setLoading] = useState(true); // State to track loading
  const [error, setError] = useState(''); // State to track error
  
  // Separate state for the selected item to be edited or viewed
  const [selectedItem, setSelectedItem] = useState(null);
  const [editData, setEditData] = useState({
    username: '',
    phoneNumber: '',
    Email: '',
    District: '',
  });
  const [add,setAdd]=useState(false)
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const [isEditing, setIsEditing] = useState(false); // Track if it's an edit modal or view modal
  const [formData, setFormData] = useState({
    name: '',
    phoneNumber: '',
    email: '',
    aadharNumber: '',
    district: '',
    password: '',
    RetypePassword: '',
    role: 'admin',
    referralid: localStorage.getItem('UserId') 
  });

  const [errorMessage, setErrorMessage] = useState('');


  useEffect(() => {
    const role = localStorage.getItem("userRole");
    if (role !== "supperadmin") {
      // alert("Access denied. You do not have permission to view this page.");
      navi("/"); // redirect to home or login page
    }
  }, [navi]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Password validation
    if (formData.password !== formData.RetypePassword) {
      setErrorMessage('Passwords do not match');
      return;
    }

    // Phone number validation (only digits, exactly 10 digits)
    if (!/^\d{10}$/.test(formData.phoneNumber)) {
      setErrorMessage('Phone number must be exactly 10 digits');
      return;
    }

    // Aadhar validation (exactly 12 digits)
    if (!/^\d{12}$/.test(formData.aadharNumber)) {
      setErrorMessage('Aadhar number must be exactly 12 digits');
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/add/form`, formData);
      alert('Form submitted successfully');
      // console.log('Form submitted successfully:', response.data);

      setFormData({
        name: '',
        phoneNumber: '',
        email: '',
        aadharNumber: '',
        district: '',
        password: '',
        RetypePassword: '',
        // role: 'admin',
        referralid: localStorage.getItem('UserId') 
      });
      // console.log('',localStorage.getItem('UserId'))
      setErrorMessage('');
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Error submitting the form.');
      console.error('Error submitting the form:', error);
    }
  };
  const handleAdd = () => {
    navi('/adminform'); // Navigate to the admin form page
  };

  const handleView = async (id) => {
    try {
        const viewdata = await axios.get(`${process.env.REACT_APP_API}/viewadmin/showadmin/${id}`); 
        setSelectedItem(viewdata.data);
        setIsEditing(false);
        setShowModal(true);
    } catch (err) {
        console.error(err);
    }
};


  const handleEdit = async (id) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/viewadmin/showadmin/${id}`);
      const data = response.data;
      setEditData({
        username: data.username,
        phoneNumber: data.phoneNumber,
        Email: data.Email,
        District: data.District, // Ensure you're using the correct field
      });
      setSelectedItem(data); // Store the selected item for further reference (for PUT request)
      setIsEditing(true); // Set to edit mode
      setShowModal(true); // Show the modal
    } catch (err) {
      console.error(err);
    }
  };


const [search, setSearch] = useState("");

// Filter getData based on the search input (by username)
const filteredData = (getData ?? []).filter((user) =>
  user.username?.toLowerCase().includes(search.trim().toLowerCase())
);

const handleEditSubmit = async (e) => {
  e.preventDefault();

  if (!selectedItem?.id) {
      alert("Error: No item selected for update.");
      return;
  }

  // Ensure all fields are present
  if (!editData.username || !editData.phoneNumber || !editData.Email || !editData.District) {
      alert("All fields are required.....");
      return;
  }

  // console.log("Edit Data being sent:", editData); // Debugging

  try {
      const response = await axios.put(
          `${process.env.REACT_APP_API}/admin/updateadmin/${selectedItem.id}`,
          editData,
          { headers: { "Content-Type": "application/json" } }
      );

      if (response.status === 200) {
          alert("Data updated successfully!");
          setShowModal(false);
          fetchData(); // Refresh table
      } else {
          alert("Failed to update data. Please try again.");
      }
  } catch (err) {
      console.error("Update error:", err.response?.data || err.message);
      alert(`Failed to update data: ${err.response?.data?.message || "Server error"}`);
  }
};

  const handleCloseModal = () => {
    setShowModal(false); // Close the modal
  };

  // Fetch data when the component mounts
  const fetchData = async () => {
    // console.log(API)
    try {
        const response = await axios.get(`${process.env.REACT_APP_API}/getadmin/admintable`);
        setgetData(response.data); // Set the fetched data in state
    } catch (err) {
        setError('Failed to fetch form data. Please try again later.');
    } finally {
        setLoading(false); // Stop loading after data is fetched or error occurs
    }
};

  useEffect(() => {
    fetchData(); // Fetch data on component mount
  }, []);


  const districts = [
    "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri", "Dindigul", 
    "Erode", "Kancheepuram", "Kanniyakumari", "Karur", "Madurai", 
    "Nagapattinam", "Namakkal", "The Nilgiris", "Perambalur", "Pudukottai", 
    "Ramanathapuram", "Salem", "Sivagangai", "Thanjavur", "Theni", 
    "Thiruvallur", "Thiruvannamalai", "Thiruvarur", "Thoothukudi", 
    "Tiruchirappalli", "Tirunelveli", "Vellore", "Villupuram", "Virudhunagar", 
    "Ariyalur", "Krishnagiri", "Tiruppur", "Chengalpattu", "Kallakurichi", 
    "Ranipet", "Tenkasi", "Tirupathur", "Mayiladuthurai"
  ];

  return (
    <div style={{ overflow: 'hidden' }}>
      {/* Header Section */}
      <div className='admin_header'>
        <div className='admin_header_logo'>
          <img src="./assets/logo.png" alt=""  style={{width:'70%',height:'100%'}}/>
        </div>
        <div className='admin_header_text'>
          <h2>தமிழ்நாடு ராம்ஜி கல்வி மற்றும் பொருளாதார மேம்பாட்டு அறக்கட்டளை , பதிவு எண்: 38/2015</h2>
        </div>
      </div>

      {/* Button to navigate to the form page */}
      {/* <div style={{ width: '100%', height: '100px', display: 'flex', justifyContent: 'end' }}>
        <div
          onClick={handleAdd}
          style={{
            width: '8%',
            height: '77%',
            backgroundColor: 'blueviolet',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          ADD +
        </div>
      </div> */}
     
      {/* Table Container for Horizontal Scrolling */}
      <div  className='tablecontainer'>
        {/* Table displaying the form data */}

        <div className="search-container">
        <input
          type="text"
          placeholder="Search by username..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button className="add-btn" onClick={()=>setAdd(!add)}
        // onClick={handleAdd}
        >
          + Add
        </button>
      </div>
        <div style={{overflowX:'auto'}}>
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p style={{ color: 'red' }}>{error}</p>
          ) : (
            <table border="1" >
              <thead >
                <tr>
                  <th ><h5>S.No</h5></th>
                  <th ><h5>Name</h5></th>
                  <th ><h5>Phone Number</h5></th>
                  <th ><h5>Email</h5></th>
                  <th ><h5>District</h5></th>
                  <th ><h5>View</h5></th>
                  <th ><h5>Edit</h5></th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((item, index) => (
                    <tr key={item.id} >
                      <td >{index + 1}</td>
                      <td >{item.username}</td>
                      <td >{item.phoneNumber}</td>
                      <td >{item.Email}</td>
                      <td >{item.District}</td>
                      <td >
                        <button
                          style={{ backgroundColor: 'blueviolet' }}
                          onClick={() => handleView(item.id)}
                        >
                          View
                        </button>
                      </td>
                      <td >
                        <button
                          style={{ backgroundColor: 'blueviolet' }}
                          onClick={() => handleEdit(item.id)} // Edit button click
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" style={{ textAlign: 'center' }}>No data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Modal for displaying the selected data */}
      {showModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          onClick={handleCloseModal}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '10px',
              width: '400px',
              minHeight: '200px',
              overflowY: 'auto',
              position: 'relative',
            }}
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
          >
            
            {showModal && (
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={handleCloseModal}
              >
                <div
                  style={{
                    backgroundColor: 'white',
                    padding: '20px',
                    borderRadius: '10px',
                    width: '90%',
                    maxWidth: '600px',  // Set a maximum width for better mobile responsiveness
                    minHeight: '250px',
                    overflowY: 'auto',
                    position: 'relative',
                  }}
                  onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
                >
                  {isEditing ? (
                    <>
                      <h3>Edit Details</h3>
                      <form onSubmit={handleEditSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
                        <label>Name:</label>
                        <input
                          type="text"
                          value={editData.username}
                          onChange={(e) => setEditData({ ...editData, username: e.target.value })}
                          required
                          style={{
                            padding: '8px',
                            marginBottom: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                          }}
                        />
                        <label>Phone Number:</label>
                        <input
                          type="text"
                          value={editData.phoneNumber}
                          onChange={(e) => setEditData({ ...editData, phoneNumber: e.target.value })}
                          required
                          style={{
                            padding: '8px',
                            marginBottom: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                          }}
                        />
                        <label>Email:</label>
                        <input
                          type="email"
                          value={editData.Email}
                          onChange={(e) => setEditData({ ...editData, Email: e.target.value })}
                          required
                          style={{
                            padding: '8px',
                            marginBottom: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                          }}
                        />
                        <label>District:</label>
                        <select
                          id="district"
                          value={editData.District}  // Use editData here
                          onChange={(e) => setEditData({ ...editData, District: e.target.value })}
                          style={{
                            padding: '8px',
                            marginBottom: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                          }}
                        >
                          <option value="">Select a district</option>
                          {districts.map((district, index) => (
                            <option key={index} value={district}>
                              {district}
                            </option>
                          ))}
                        </select>
                        <button
                          type="submit"
                          style={{
                            padding: '10px 20px',
                            backgroundColor: 'blueviolet',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            marginTop: '15px',
                          }}
                        >
                          Save Changes
                        </button>
                      </form>
                    </>
                  ) : (
                    <>
                      <h3>View Details</h3>
                      <p><strong>Name:</strong> {selectedItem?.username}</p>
                      <p><strong>UserId:</strong> {selectedItem?.UserId}</p>
                      <p><strong>Phone Number:</strong> {selectedItem?.phoneNumber}</p>
                      <p><strong>Email:</strong> {selectedItem?.Email}</p>
                      <p><strong>Password:</strong> {selectedItem?.viewpass}</p>
                    </>
                  )}
                  <button
                    onClick={handleCloseModal}
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      backgroundColor: 'red',
                      color: 'white',
                      border: 'none',
                      padding: '5px 10px',
                      cursor: 'pointer',
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

{add && (
  <div className="modal-overlay">
    <div className="modal-container">
      <form onSubmit={handleSubmit}>
        <input type="text" id="name" placeholder="Name" value={formData.name} onChange={handleChange} required />
        <input type="text" id="phoneNumber" placeholder="Phone Number" maxLength={10} value={formData.phoneNumber} 
          onChange={(e) => { 
            const newValue = e.target.value.replace(/[^0-9]/g, ''); 
            setFormData((prevData) => ({ ...prevData, phoneNumber: newValue })); 
          }} required 
        />
        <input type="email" id="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
        <input type="text" id="aadharNumber" placeholder="Aadhar Number" maxLength={12} value={formData.aadharNumber} 
          onChange={(e) => { 
            const newValue = e.target.value.replace(/[^0-9]/g, ''); 
            setFormData((prevData) => ({ ...prevData, aadharNumber: newValue })); 
          }} required 
        />
        <select id="district" value={formData.district} onChange={handleChange} required>
          <option value="">Select a district</option>
          {districts.map((district, index) => (
            <option key={index} value={district}>{district}</option>
          ))}
        </select>
        <input type="password" id="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
        <input type="password" id="RetypePassword" placeholder="Retype Password" value={formData.RetypePassword} onChange={handleChange} required />

        {errorMessage && <p className="error-message">{errorMessage}</p>}

        {/* Submit and Close Buttons */}
        <div className="button-container">
          <button type="submit" className="submit-btn">Submit</button>
          <button type="button" className="close-btn" onClick={() => setAdd(false)}>Close</button>
        </div>
      </form>
    </div>
  </div>
)}


    </div>
  );
};

export default Adminadd;
